module.exports = __webpack_public_path__ + "media/images/countryrect/fm-41786de34ce3906c8bf66c938fc9f55a.svg";